module.exports = __webpack_public_path__ + "img/header-mobile-back.61e2d00c.png";